'use strict';

var map = { function: true, object: true };

module.exports = function (x) {
	return ((x != null) && map[typeof x]) || false;
};



//////////////////
// WEBPACK FOOTER
// ../~/es5-ext/object/is-object.js
// module id = 169
// module chunks = 0